import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#trainee_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Job Placement Summary")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee_info",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-3 mt-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Type", -1)
const _hoisted_19 = { class: "col-md-3 mt-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_21 = { class: "col-md-2 mt-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Batch", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "col-md-2 mt-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Gender", -1)
const _hoisted_26 = { class: "col-md-2 mt-5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Trainee Job Placement Summary", -1)
const _hoisted_32 = { class: "card mb-5 mb-xl-10" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, null, -1)
const _hoisted_34 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_35 = { class: "collapse show" }
const _hoisted_36 = { class: "card-body border-top p-3" }
const _hoisted_37 = { class: "row w-100 m-0" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_39 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  class: "current",
  "data-kt-stepper-element": "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.trainee.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trancheChange()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Tranche"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Tranche")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createVNode(_component_el_select, {
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  class: "form-select-solid",
                  placeholder: "Select Training Partner",
                  modelValue: _ctx.trainee.entity_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                  style: {"width":"100%"},
                  filterable: "",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trainingInstitute()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Training Partner"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Training Partner")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: assoc.id,
                        label: assoc.entity_short_name,
                        value: assoc.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Institute",
                  modelValue: _ctx.trainee.training_institute_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getCourseList()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Institute"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Institute")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: inst.id,
                        label: inst.institute_name,
                        value: inst.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(inst.institute_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Type",
                  modelValue: _ctx.trainee.course_type,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainee.course_type) = $event)),
                  style: {"width":"100%"},
                  onChange: _ctx.btnCheckStatus
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "upskill",
                      label: "Up Skill"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Up Skill")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "newentrant",
                      label: "New Entrant"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("New Entrant")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  placeholder: "Select Course",
                  modelValue: _ctx.trainee.course_info_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trainee.course_info_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getBatchList()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Course"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Course")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: course.id,
                        label: course.course_name,
                        value: course.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(course.course_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  placeholder: "Select Batch",
                  modelValue: _ctx.trainee.batch_info_id,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.trainee.batch_info_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Batch"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Batch")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: batch.id,
                        label: batch.batch_sequence_number,
                        value: batch.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(batch.batch_sequence_number), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  modelValue: _ctx.trainee.gender,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.trainee.gender) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  disabled: _ctx.validated == 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "--Select--"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select--")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, { value: "Male" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Male")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, { value: "Female" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Female")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, { value: "Other" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Other")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                _createVNode(_component_ErrorMessage, {
                  name: "gender",
                  class: "fv-plugins-message-container invalid-feedback"
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getTraineeList())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_27
                ])
              ])
            ]),
            (_ctx.showtraineeInfo == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
              : _createCommentVNode("", true),
            (_ctx.showtraineeInfo == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_41),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_43),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_45)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.traineeList,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-entity": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.entity_info?.entity_short_name), 1)
                              ]),
                              "cell-institute": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.institute_info?.institute_name), 1)
                              ]),
                              "cell-course_info": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.course_info?.course_name), 1)
                              ]),
                              "cell-tranche": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.tranche_info?.label), 1)
                              ]),
                              "cell-batch_info": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.batch_info?.batch_number), 1)
                              ]),
                              "cell-reg_no": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.registration_number), 1)
                              ]),
                              "cell-name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.trainee_name), 1)
                              ]),
                              "cell-gender": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.gender), 1)
                              ]),
                              "cell-birth_date": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.date_of_birth
                                ? _ctx.moment(industry?.date_of_birth).format(
                                    "DD-MM-YYYY"
                                  )
                                : industry?.date_of_birth), 1)
                              ]),
                              "cell-phone": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.mobile), 1)
                              ]),
                              "cell-alt_mob": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.alternative_mobile), 1)
                              ]),
                              "cell-email": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.email), 1)
                              ]),
                              "cell-org_name": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment
                                ?.organization_name), 1)
                              ]),
                              "cell-org_add": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment
                                ?.organization_address), 1)
                              ]),
                              "cell-j_date": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.joining_date), 1)
                              ]),
                              "cell-designation": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.designation), 1)
                              ]),
                              "cell-selary": _withCtx(({ row: industry }) => [
                                _createTextVNode(_toDisplayString(industry?.current_trainee_employment?.salary), 1)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}